import React, { useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  Tooltip
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';

const AddCustomInput = ({ customValidation, onCustomSelect, placeholder, buttonLabel, onClose }) => {
  const [customEditing, setCustomEditing] = useState(false);
  const [customError, setError] = useState({ message: '' });
  const [customSubmitting, setSubmitting] = useState(false);

  const addCustomItem = async () => {
    setSubmitting(true);
    const inputValue = document.querySelector('#dropdown-custom-item').value;

    if (!inputValue.trim().length) {
      setError({ message: 'Must include characters besides spaces' });
      setSubmitting(false);
      return;
    }

    const error = customValidation(inputValue);

    if (error && !error?.valid) {
      setError(error);
      setSubmitting(false);
      return;
    }

    setError({ valid: true, message: '' });
    await onCustomSelect(inputValue);
    setSubmitting(false);
    setCustomEditing(false);
    onClose();
  };

  if (customEditing) {
    return (
      <Flex direction="column">
        <Flex alignItems="center" pb="0.8rem" px="0.8rem">
          <InputGroup>
            <InputLeftElement
              children={(
                <Tooltip label="Click to Add">
                  <IconButton
                    aria-label="create-new"
                    borderRadius="xs"
                    icon={<Icon as={BsPlus} boxSize={4} />}
                    isDisabled={customSubmitting}
                    size="xs"
                    onClick={() => addCustomItem()}
                  />
                </Tooltip>
                            )}
              justifyContent="flex-start"
            />
            <Input
              _focus={{
                borderBottomColor: customError.message
                  ? colors.error.primary['600']
                  : colors.primaryScale['600'],
                borderBottomWidth: '2px',
                outline: 'none'
              }}
              _placeholder={{ color: colors.greyScale['500'] }}
              borderBottomColor={customError.message ? colors.error.primary['600'] : colors.primaryScale['600']}
              fontSize="sm"
              height="40px"
              id="dropdown-custom-item"
              placeholder={placeholder}
              variant="flushed"
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
              }}
            />
          </InputGroup>
        </Flex>
        <Box mb="5px" pl="0.8rem" pr={2} textAlign="left">
          <Text color={colors.error.primary['600']} textStyle="bodyXs500">
            {customError.message}
          </Text>
        </Box>
      </Flex>
    );
  }

  return (
    <Button
      leftIcon={<Icon as={BsPlus} mr={2} />}
      variant="textPrimary"
      onClick={evt => {
        evt.stopPropagation();
        evt.preventDefault();
        setCustomEditing(true);
      }}
    >
      {buttonLabel}

    </Button>
  );
};

AddCustomInput.propTypes = {
  customValidation: PropTypes.func,
  onCustomSelect: PropTypes.func,
  placeholder: PropTypes.string,
  buttonLabel: PropTypes.string,
  onClose: PropTypes.func
};

export default AddCustomInput;
